import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { cn } from "@/lib/utils";
import { DateRangePicker } from "./DateRangePicker";
import { useTranslation } from "@/contexts/LanguageContext";

export type Period = "7d" | "30d" | "90d" | "custom";

interface PeriodFilterProps {
  selectedPeriod: Period;
  onPeriodChange: (period: Period) => void;
  customStartDate?: Date;
  customEndDate?: Date;
  onCustomDateChange?: (startDate: Date | undefined, endDate: Date | undefined) => void;
}

export function PeriodFilter({ 
  selectedPeriod, 
  onPeriodChange,
  customStartDate,
  customEndDate,
  onCustomDateChange 
}: PeriodFilterProps) {
  const { t } = useTranslation();

  const periods: { value: Period; label: string }[] = [
    { value: "7d", label: t('last7days') },
    { value: "30d", label: t('currentMonth') },
    { value: "90d", label: t('lastQuarter') },
    { value: "custom", label: t('customized') },
  ];

  return (
    <div className="flex flex-wrap gap-2 items-center">
      {periods.map((period) => (
        <Button
          key={period.value}
          variant={selectedPeriod === period.value ? "default" : "outline"}
          size="sm"
          onClick={() => onPeriodChange(period.value)}
          className={cn(
            "transition-smooth",
            selectedPeriod === period.value && "gradient-primary"
          )}
        >
          {period.value === "custom" && <Calendar className="mr-2 h-4 w-4" />}
          {period.label}
        </Button>
      ))}
      {selectedPeriod === "custom" && onCustomDateChange && (
        <DateRangePicker
          startDate={customStartDate}
          endDate={customEndDate}
          onDateRangeChange={onCustomDateChange}
        />
      )}
    </div>
  );
}
